import { DpsPostingInterface } from './dps-posting.interface';
import { PaginationInterface } from '../pagination.interface';

export interface DpsPostingSearchResultsInterface {
  results?: DpsPostingInterface[];
  pagination?: PaginationInterface;
  totalElements?: number;
}
